import { useRouter } from '@application/utils';
import type { CountryCode } from '@gql/graphql';
import type { ShelterListPageFormValues } from '@presentation/pages';
import { useCallback, useMemo } from 'react';
import { FORM_INITIAL_VALUES } from './constants';

export const useSearch = () => {
  const { infoFromCurrentPath, setCurrentSearch } = useRouter();

  const setSearchFromValues = useCallback(
    (values: ShelterListPageFormValues) => {
      setCurrentSearch({
        countries: values.countries,
        regions: values.regions,
        spokenLanguages: values.spokenLanguages,
      });
    },
    [setCurrentSearch],
  );

  const valuesFromSearch = useMemo((): Partial<ShelterListPageFormValues> => {
    const { countries, spokenLanguages, regions } = infoFromCurrentPath.search ?? {};

    return {
      countries: (countries as CountryCode[]) ?? FORM_INITIAL_VALUES.countries,
      spokenLanguages: (spokenLanguages as string[]) ?? FORM_INITIAL_VALUES.spokenLanguages,
      regions: (regions as string[]) ?? FORM_INITIAL_VALUES.regions,
    };
  }, [infoFromCurrentPath.search]);

  return { setSearchFromValues, valuesFromSearch };
};
